import { render, staticRenderFns } from "./NewsNotice.vue?vue&type=template&id=7da3c03b&scoped=true"
import script from "./NewsNotice.vue?vue&type=script&lang=js"
export * from "./NewsNotice.vue?vue&type=script&lang=js"
import style0 from "./NewsNotice.vue?vue&type=style&index=0&id=7da3c03b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3c03b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da3c03b')) {
      api.createRecord('7da3c03b', component.options)
    } else {
      api.reload('7da3c03b', component.options)
    }
    module.hot.accept("./NewsNotice.vue?vue&type=template&id=7da3c03b&scoped=true", function () {
      api.rerender('7da3c03b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewsNotice.vue"
export default component.exports